import { matchPath } from 'react-router-dom'
import { ClientPageTabNames, ROUTES } from '@common/constants/routes'

export type { RouteKey } from '@common/constants/routes'
export { ClientPageTabNames, ROUTES }

export enum ClientVisualizationsPageTabNames {
  Receivables = 'Receivables',
  Payable = 'Payables',
  Inventory = 'Inventory',
}

export enum ClientSettingsTabNames {
  Personal = 'Personal',
  Security = 'Security',
  Integrations = 'Integrations',
}

/**
 * The client portal's Settings tabs are local state, not routes, so a deep link seeds the
 * initial tab through this query param.
 */
export const SETTINGS_TAB_QUERY_PARAM = 'tab'

export const CLIENT_INTEGRATIONS_SETTINGS_PATH = `${ROUTES.SETTINGS}?${SETTINGS_TAB_QUERY_PARAM}=${ClientSettingsTabNames.Integrations}`

export enum ClientPageActivityOption {
  AccountActivity = 'Activity',
  LoanLedger = 'Daily Ledger',
}

export const CLIENT_PAGE_ACTIVITY_OPTIONS = [
  {
    value: ClientPageActivityOption.AccountActivity,
    label: ClientPageActivityOption.AccountActivity,
  },
  {
    value: ClientPageActivityOption.LoanLedger,
    label: ClientPageActivityOption.LoanLedger,
  },
]

const BLANK_LAYOUT_ROUTES = [
  ROUTES.LOGIN,
  ROUTES.LOGIN_ERROR,
  ROUTES.BBC_SIGN_SUCCESS,
  ROUTES.SIGNUP,
  ROUTES.RESET_PASSWORD,
  ROUTES.PASSWORD_SETUP,
  ROUTES.PASSWORD_RECOVERY,
  ROUTES.CLIENT_INTEGRATIONS.replace(':id', ''),
  ROUTES.EXTERNAL_API_DOCS,
  '/reset-password/',
  '/password-setup/',
]

export const isBlankLayoutRoute = (pathname: string) => {
  return BLANK_LAYOUT_ROUTES.some((route) =>
    matchPath(
      {
        path: route,
        end: true,
      },
      pathname,
    ),
  )
}

export { BLANK_LAYOUT_ROUTES }
